<template>
  <article id="capa">
    <!-- Texto -->
    <h1 class="blend" :style="'background-image: url(' + require('../assets/extras/claquete.jpg') + ')'">
      <span>C</span><span>i</span><span>n</span><span>e</span><span>m</span><span>a</span>
      <span>N</span><span>o</span><span>v</span><span>a</span><span>s</span><span>M</span><span>í</span><span>d</span><span>i</span><span>a</span><span>s</span>
      <span>P</span><span>r</span><span>o</span><span>d</span><span>u</span><span>ç</span><span>ã</span><span>o</span><span>C</span><span>u</span><span>l</span><span>t</span><span>u</span><span>r</span><span>a</span><span>l</span>
    </h1>

    <!-- Corpo -->
    <section>
      <svg viewBox="0 0 148.1 235">
        <path d="M34.6,215.7c0,1.6,1.2,19.3-16.5,19.3c-12.8,0-15.9-9.6-16.3-14h7.8c0.3,1.7,1.4,7,8.6,7c10.1,0,8.6-10.7,8.6-15.2
          c-4.4,5.5-15.3,7.1-22-0.2c-6.5-7-5.3-19.7-0.3-25.2c8.2-9.2,20.5-5.2,22.4-1.7v-2.8h7.8V215.7z M17.7,188.8
          c-12.5,0-12.4,21.7,0,21.7C30.1,210.5,30.5,188.8,17.7,188.8z"/>
        <path d="M44.5,182.7h7.8v2c1.4-1.5,7.9-5.2,14.3-0.9L64,191c-8.2-4.2-11.7,0.4-11.7,8.1v17.5h-7.8V182.7z"/>
        <path d="M96,182.7v2.9c-5.7-7.3-26.5-5.5-26.5,13.9c0,18.5,18.9,21.6,26.5,14.5v2.5h7.8v-33.8H96z M86.8,210.5
          c-12.4,0-12.7-21.7,0.1-21.7C99.8,188.8,99.9,210.5,86.8,210.5z"/>
        <path d="M130.1,181.8c23.8,0,24.2,35.7-0.1,35.7C106.2,217.5,106,181.8,130.1,181.8z M130.1,210.5c13.4,0,13.6-21.7,0-21.7
          C117,188.8,116.5,210.5,130.1,210.5z"/>
        <path d="M102.8,166.8c-2.8,3.6-2.8,5.6-10.1,1.5v7.6c2.4,1,9.3,4.7,14.6-5.3L102.8,166.8z"/>
        <path d="M0.3,87.5c0,33.6,22.2,61.7,55.2,70.2c0.3-4.9,0.8-9.1,1.5-13c-26.9-8.1-42.3-28.9-42.3-57.2c0-20.7,7.4-36.5,25.9-50.9
          c7.5-5.8,14.5-11.5,15.8-20.8C23.4,24,0.3,53.4,0.3,87.5z"/>
        <path d="M81.5,0c-7.7,0.9-13,7.2-13.9,16.7c-1.5,15.5-12.4,23.7-15.2,25.6C35.1,54.1,25.5,67.3,25.5,87.1
          c0,21.8,14.5,41.3,35.3,47.4c2.2-5.6,4.8-9.1,6.6-11c0-0.1,0.1-0.1,0.1-0.2C42,116.8,40,94,40,87.1c0-8.7,5.3-19.9,17.1-28.5
          C74.7,45.8,81.5,37.5,81.5,0z"/>
        <path d="M148.1,87c0-33.3-24-63.8-55.8-71.1c-0.3,5-0.8,9.4-1.6,13.4c26.4,10,43.6,34.5,43.6,57.7c0,19-7.2,33.3-23.9,45.8
          c-11.9,8.9-15.9,14.9-16.8,24.7C112.7,154.7,148.1,128.5,148.1,87z"/>
        <path d="M104.8,124c12.7-9.8,19.1-21.2,19.1-37.1c0-19.7-15.9-40.5-36.3-47.6c-3,7.6-7.7,12.4-7.7,12.5
          c17.5,6.1,28.3,19.5,28.3,35.2c0,7.6-3.4,19.6-16.2,28.8c-22.4,16.1-25.6,22-25.6,59.6c5.3,0.5,9.9,0.5,15.2,0.1
          C81.5,143.3,85.7,138.8,104.8,124z"/>
      </svg>
      <router-link :to="{ path: 'Sobre' }" id="scroll-down">
        <span class="arrow-down">
        <!-- css generated icon -->
        </span>
      </router-link>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section {display: flex; align-items: center; justify-content: space-around;}
section svg {width: 50%; max-height: 75%;}

  /* --- SETA --- */
  #scroll-down {
    display: block;
    position: absolute;
    padding-top: 5vh;
    bottom: 5vh;
    width: 20px;
    text-align: center;
    cursor: pointer;
  }
  .arrow-down {
    display: block;
    margin: 0 auto;
    height: 5vh;
  }
  .arrow-down::after {
    content: '';
    display: block;
    margin: auto;
    padding: 0;
    width: 1vh;
    height: 1vh;
    border-top: 2px solid #000;
    border-right: 2px solid #000;
    transform: rotate(135deg);
  }
  #scroll-down::before {
    animation: elasticus 2s cubic-bezier(1, 0, 0, 1) infinite;
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -1px;
    width: 2px;
    height: 6.25vh;
    background: #000;
    content: ' ';
  }
  #scroll-down:hover:before {background: #d55349}
  #scroll-down:hover .arrow-down::after { border-color: #d55349}

  @keyframes elasticus {
    0% {
      transform-origin: 0% 0%;
      transform: scale(1, 0);
    }
    50% {
      transform-origin: 0% 0%;
      transform: scale(1, 1);
    }
    50.1% {
      transform-origin: 0% 100%;
      transform: scale(1, 1);
    }
    100% {
      transform-origin: 0% 100%;
      transform: scale(1, 0);
    }
  }

/* --- LETREIRO --- */
  /* CINEMA */
    h1 span:nth-child(1) { /* C */
    	grid-column: 2;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 0s infinite;
    }
    h1 span:nth-child(2) { /* i */
    	grid-column: 1;
    	grid-row: 2;
    	opacity: 0;
    	animation: letters 15s 0.1s infinite;
    }
    h1 span:nth-child(3) { /* n */
    	grid-column: 8;
    	grid-row: 4;
    	opacity: 0;
    	animation: letters 15s 0.2s infinite;
    }
    h1 span:nth-child(4) { /* e */
    	grid-column: 8;
    	grid-row: 5;
    	opacity: 0;
    	animation: letters 15s 0.3s infinite;
    }
    h1 span:nth-child(5) { /* m */
    	grid-column: 1;
    	grid-row: 7;
    	opacity: 0;
    	animation: letters 15s 0.4s infinite;
    }
    h1 span:nth-child(6) { /* a */
    	grid-column: 6;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 0.5s infinite;
    }
  /* NOVAS MIDIAS */
    h1 span:nth-child(7) { /* N */
    	grid-column: 3;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 5s infinite;
    }
    h1 span:nth-child(8) { /* o */
    	grid-column: 4;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 5.1s infinite;
    }
    h1 span:nth-child(9) { /* v */
    	grid-column: 7;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 5.2s infinite;
    }
    h1 span:nth-child(10) { /* a */
    	grid-column: 1;
    	grid-row: 2;
    	opacity: 0;
    	animation: letters 15s 5.3s infinite;
    }
    h1 span:nth-child(11) { /* s */
    	grid-column: 1;
    	grid-row: 3;
    	opacity: 0;
    	animation: letters 15s 5.4s infinite;
    }
    h1 span:nth-child(12) { /* M */
    	grid-column: 8;
    	grid-row: 5;
    	opacity: 0;
    	animation: letters 15s 5.5s infinite;
    }
    h1 span:nth-child(13) { /* í */
    	grid-column: 8;
    	grid-row: 6;
    	opacity: 0;
    	animation: letters 15s 5.6s infinite;
    }
    h1 span:nth-child(14) { /* d */
    	grid-column: 1;
    	grid-row: 7;
    	opacity: 0;
    	animation: letters 15s 5.7s infinite;
    }
    h1 span:nth-child(15) { /* i */
    	grid-column: 3;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 5.8s infinite;
    }
    h1 span:nth-child(16) { /* a */
    	grid-column: 7;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 5.9s infinite;
    }
    h1 span:nth-child(17) { /* s */
    	grid-column: 8;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 6s infinite;
    }
  /* PRODUÇÃO CULTURAL */
    h1 span:nth-child(18) { /* P */
    	grid-column: 1;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 10s infinite;
    }
    h1 span:nth-child(19) { /* r */
    	grid-column: 2;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 10.1s infinite;
    }
    h1 span:nth-child(20) { /* o */
    	grid-column: 3;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 10.2s infinite;
    }
    h1 span:nth-child(21) { /* d */
    	grid-column: 6;
    	grid-row: 1;
    	opacity: 0;
    	animation: letters 15s 10.3s infinite;
    }
    h1 span:nth-child(22) { /* u */
    	grid-column: 8;
    	grid-row: 2;
    	opacity: 0;
    	animation: letters 15s 10.4s infinite;
    }
    h1 span:nth-child(23) { /* ç */
    	grid-column: 1;
    	grid-row: 3;
    	opacity: 0;
    	animation: letters 15s 10.5s infinite;
    }
    h1 span:nth-child(24) { /* ã */
    	grid-column: 1;
    	grid-row: 4;
    	opacity: 0;
    	animation: letters 15s 10.6s infinite;
    }
    h1 span:nth-child(25) { /* o */
    	grid-column: 1;
    	grid-row: 5;
    	opacity: 0;
    	animation: letters 15s 10.7s infinite;
    }
    h1 span:nth-child(26) { /* C */
    	grid-column: 8;
    	grid-row: 4;
    	opacity: 0;
    	animation: letters 15s 10.3s infinite;
    }
    h1 span:nth-child(27) { /* u */
    	grid-column: 8;
    	grid-row: 5;
    	opacity: 0;
    	animation: letters 15s 10.4s infinite;
    }
    h1 span:nth-child(28) { /* l */
    	grid-column: 8;
    	grid-row: 6;
    	opacity: 0;
    	animation: letters 15s 10.5s infinite;
    }
    h1 span:nth-child(29) { /* t */
    	grid-column: 1;
    	grid-row: 7;
    	opacity: 0;
    	animation: letters 15s 10.6s infinite;
    }
    h1 span:nth-child(30) { /* u */
    	grid-column: 2;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 10.7s infinite;
    }
    h1 span:nth-child(31) { /* r */
    	grid-column: 5;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 10.8s infinite;
    }
    h1 span:nth-child(32) { /* a */
    	grid-column: 6;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 10.9s infinite;
    }
    h1 span:nth-child(33) { /* l */
    	grid-column: 8;
    	grid-row: 8;
    	opacity: 0;
    	animation: letters 15s 11s infinite;
    }

    @keyframes letters {
      0% {opacity: 0}
      1% {opacity: 1}
      31% {opacity: 1}
      33% {opacity: 0}
      100% {opacity: 0}
    }


@media (min-width: 768px) {
  /*
    ##Device = Tablets, Ipads
    ##Screen = B/w 768px to 1024px
  */

  #scroll-down {bottom: 0;}

  /* --- LETREIRO --- */
    /* CINEMA */
      h1 span:nth-child(1) { /* C */
      	grid-column: 1;
      	grid-row: 1;
      }
      h1 span:nth-child(2) { /* i */
      	grid-column: 2;
      	grid-row: 2;
      }
      h1 span:nth-child(3) { /* n */
      	grid-column: 6;
      	grid-row: 5;
      }
      h1 span:nth-child(4) { /* e */
      	grid-column: 7;
      	grid-row: 5;
      }
      h1 span:nth-child(5) { /* m */
      	grid-column: 1;
      	grid-row: 7;
      }
      h1 span:nth-child(6) { /* a */
      	grid-column: 6;
      	grid-row: 8;
      }
    /* NOVAS MIDIAS */
      h1 span:nth-child(7) { /* N */
      	grid-column: 3;
      	grid-row: 2;
      }
      h1 span:nth-child(8) { /* o */
      	grid-column: 4;
      	grid-row: 2;
      }
      h1 span:nth-child(9) { /* v */
      	grid-column: 6;
      	grid-row: 3;
      }
      h1 span:nth-child(10) { /* a */
      	grid-column: 4;
      	grid-row: 4;
      }
      h1 span:nth-child(11) { /* s */
      	grid-column: 5;
      	grid-row: 4;
      }
      h1 span:nth-child(12) { /* M */
      	grid-column: 8;
      	grid-row: 5;
      }
      h1 span:nth-child(13) { /* í */
      	grid-column: 1;
      	grid-row: 6;
      }
      h1 span:nth-child(14) { /* d */
      	grid-column: 2;
      	grid-row: 6;
      }
      h1 span:nth-child(15) { /* i */
      	grid-column: 4;
      	grid-row: 7;
      }
      h1 span:nth-child(16) { /* a */
      	grid-column: 6;
      	grid-row: 7;
      }
      h1 span:nth-child(17) { /* s */
      	grid-column: 5;
      	grid-row: 8;
      }
    /* PRODUÇÃO CULTURAL */
      h1 span:nth-child(18) { /* P */
      	grid-column: 6;
      	grid-row: 1;
      }
      h1 span:nth-child(19) { /* r */
      	grid-column: 7;
      	grid-row: 1;
      }
      h1 span:nth-child(20) { /* o */
      	grid-column: 8;
      	grid-row: 1;
      }
      h1 span:nth-child(21) { /* d */
      	grid-column: 3;
      	grid-row: 2;
      }
      h1 span:nth-child(22) { /* u */
      	grid-column: 5;
      	grid-row: 3;
      }
      h1 span:nth-child(23) { /* ç */
      	grid-column: 8;
      	grid-row: 3;
      }
      h1 span:nth-child(24) { /* ã */
      	grid-column: 1;
      	grid-row: 4;
      }
      h1 span:nth-child(25) { /* o */
      	grid-column: 2;
      	grid-row: 4;
      }
      h1 span:nth-child(26) { /* C */
      	grid-column: 6;
      	grid-row: 4;
      }
      h1 span:nth-child(27) { /* u */
      	grid-column: 4;
      	grid-row: 5;
      }
      h1 span:nth-child(28) { /* l */
      	grid-column: 5;
      	grid-row: 5;
      }
      h1 span:nth-child(29) { /* t */
      	grid-column: 6;
      	grid-row: 6;
      }
      h1 span:nth-child(30) { /* u */
      	grid-column: 2;
      	grid-row: 7;
      }
      h1 span:nth-child(31) { /* r */
      	grid-column: 8;
      	grid-row: 7;
      }
      h1 span:nth-child(32) { /* a */
      	grid-column: 5;
      	grid-row: 8;
      }
      h1 span:nth-child(33) { /* l */
      	grid-column: 6;
      	grid-row: 8;
      }
}
</style>
